import React, { useEffect } from 'react'
import { Add_Field_Api } from '../../API/FieldApi';
import { Button, Checkbox, Col, Form, Input, InputNumber, Layout, Row } from 'antd';
import { SaveOutlined, RollbackOutlined, CheckOutlined } from '@ant-design/icons';
// =================================================================
export const AddFieldComponent = ({ objectTypeId, setLoading, showMessage, rowInserted, cancelInsert }) => {
  // =================================================================
  const [form] = Form.useForm();
  // =================================================================
  useEffect(() => {
    form.setFieldsValue({ isActive: true });
  }, []);
  // =================================================================
  const onSubmit = async (values) => {
    try {
      setLoading(true);
      values.objectTypeId = objectTypeId;
      let data = await Add_Field_Api(values);
      setLoading(false);
      rowInserted();
      if (data.messageStatus == "Successful")
        showMessage(data.message, "Successful")
      else
        showMessage(data.message, "error")
    }
    catch (error) {
      setLoading(false);
      showMessage("خطا در ارتباط با سرور", "error")
    }
  };
  // =================================================================
  const onFinishFailed = (errorInfo) => {
    showMessage(errorInfo, "error")
  };
  // =================================================================
  return (
    <>
      <div className='sectionTitle'>
        <h2 >
          اضافه کردن فیلد جدید
        </h2>
      </div>

      <div className='container'>
        <Form
          name="basic"
          form={form}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
          onFinish={onSubmit}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            name="title"
            label="عنوان"
            rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
          >
            <Input placeholder='عنوان' />
          </Form.Item>
          <Form.Item
            name="comment"
            label="شرح"
            rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
          >
            <Input placeholder='شرح' />
          </Form.Item>
          <Form.Item
            name="name"
            label="نام"
            rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
          >
            <Input placeholder='name' />
          </Form.Item>
          <Form.Item
            name="fieldType"
            label="نوع فیلد"
            rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
          >
            <Input placeholder='نوع فیلد' />
          </Form.Item>

          <Form.Item
            name="orderIndex"
            label="ترتیب"
          >
            <InputNumber />
          </Form.Item>

          <Form.Item
            label="فعال"
            name="isActive"
            valuePropName='checked'
          >
            <Checkbox ></Checkbox>
          </Form.Item>
        </Form>
      </div>
      <Row className='sectionFooter'>
        <Col xs={0} sm={0} md={8} lg={16} xl={16} >
        </Col>
        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
          <Button
            style={{ width: '98%' }}
            className='btn-primary'
            htmlType="submit"
            onClick={() => form.submit()}>
            <CheckOutlined />
            ذخیره
          </Button>
        </Col>
        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
          <Button
            className='btn-secondary'
            style={{ width: '100%' }}
            onClick={() => cancelInsert()}>
            <RollbackOutlined />
            لغو </Button>
        </Col>
      </Row>

    </>
  )
}
